import axios from 'axios';
import route from 'ziggyRoute';

export default {
    async get(params = {}) {
        let url = params.id ? route('invoices.show', { id: params.id }) : route('invoices');
        return await axios.get(url, { params });
    },
    async delete(id) {
        let url = route('invoices.destroy', { id: id });
        return await axios.delete(url);
    },
    async update(id, payload) {
        let url = route('invoices.edit', { id: id });
        let result = await axios.put(url, payload);
        return result.data.data;
    },
    async create(payload) {
        let url = route('invoices.create');
        let result = await axios.post(url, payload);
        return result.data.data;
    },
    async print(payload) {
        let url = route('invoices.print');
        return await axios.post(url, payload, { responseType: 'blob' });
    },
    async changeStatus(payload) {
        let url = route('invoices.status.edit');
        let result = await axios.post(url, payload);
        return result.data.data;
    },
    async downloadCSV(params = {}) {
        let url = route('invoices.download-csv');
        return await axios.get(url, { params });
    },
    async batch(params = {}) {
        let url = route('tools.batch-invoices');
        return await axios.post(url, params);
    },
};
